import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { TranslationService } from 'projects/dop-core/src/public-api';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './app-confirm-dialog.component.html',
  styleUrls: ['./app-confirm-dialog.component.scss']
})

export class AppConfirmDialogComponent implements OnInit, OnChanges {

  @Input() openDialog: boolean;
  @Input() header: string;
  @Input() width: number;
  @Input() height: number;
  @Input() scrollable: boolean;
  @Input() yesText = "vbeiOk";
  @Input() noText = "vbeiNo";
  @Input() disableAfterButtonClick = false;

  @Output() confirmYes: EventEmitter<any> = new EventEmitter();
  @Output() confirmNo: EventEmitter<any> = new EventEmitter();
  @Output() openDialogChange: EventEmitter<any> = new EventEmitter();

  dialogHeight = 100;
  disableButton = false;

  confirmYesClick(): void {
    if (this.disableAfterButtonClick) {
      this.disableButton = true;
    }
    this.confirmYes.emit();
  }

  confirmNoClick(isOnHide: boolean): void {
    if (this.disableAfterButtonClick) {
      this.disableButton = true;
    }
    this.confirmNo.emit(isOnHide);
  }

  resetDialog(): void {
    this.openDialogChange.emit(false);
  }

  ngOnInit(): void {
    this.disableButton = false;
    if (this.scrollable) {
      this.dialogHeight = this.height - 172;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.openDialog) {
      if (this.openDialog) {
        this.disableButton = false;
      }
    }
  }
}
